import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {FormGroup, AbstractControl, FormBuilder, Validators} from '@angular/forms';
import { SectorTypesComponent } from "../../sector-types.component";

import { BaToastNotificationService } from '../../../../../../theme/services/baToastNotification'
import { UserAccountApi, SectorTypeApi, SectorApi } from '../../../../../../theme/services/sdk';

@Component({
  selector: 'sector-type-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  providers:[UserAccountApi,SectorTypeApi,SectorApi,BaToastNotificationService]
})
export class SectorTypeForm{

  public form:FormGroup;
  public name:AbstractControl;
  public sector_id:AbstractControl;
  public submitted:boolean = false;

  sector_list:Object;
  sector_type:Object;

  constructor(fb:FormBuilder, protected user:UserAccountApi, protected sectorType:SectorTypeApi, protected sector:SectorApi, private route: ActivatedRoute, private router: Router, private toast:BaToastNotificationService, private data: SectorTypesComponent) {
    this.form = fb.group({
      'name': ['', Validators.compose([Validators.required, Validators.minLength(4)])],
      'sector_id': ['', Validators.compose([Validators.required, Validators.minLength(1)])]
    });

    this.name = this.form.controls['name'];
    this.sector_id = this.form.controls['sector_id'];
    this.user.isAuthenticated()?false:this.router.navigate(['login']);
  }

  ngOnInit() {
    this.sector.find().subscribe((res)=>{
      this.sector_list = res;
    })
    this.data.sector_type.subscribe(data=>this.sector_type=data);
  }

  public onSubmit(values:Object):void {
    this.submitted = true;
    if (this.form.valid) {
      let self = this;
      let st;

      if(this.sector_type['id']){
        st = this.sectorType.upsert({
          id: this.sector_type['id'],
          name: self.name['value'],
          sector_id: self.sector_id['value'],
        })
      }else{
        st = this.sectorType.create({
          name: self.name['value'],
          sector_id: self.sector_id['value'],
        })
      }


      st.subscribe(res => {
        let msg: string;
        this.data.refresh();
        this.form.reset();
        if(this.sector_type['id']){
          this.data.cancelSelected();
          msg = 'Record updated';
        }else{
          msg = 'New sector type added';
        }

        this.toast.success({
          heading: 'Success',
          text: msg,
          stack: 3
        });

      }, err=>{
        this.toast.error({
          heading: err.name,
          text: err.message,
          stack: 3
        });
        console.log(err);
      });
    }
  }

  cancelSelected(){
    this.data.cancelSelected();
  }


}



// WEBPACK FOOTER //
// ./src/app/pages/localization/components/sector-types/components/form/form.component.ts